import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import MonitoredRaces from "../views/MonitoredRaces";
import UpcomingRaces from "../views/UpcomingRaces";
import Statistics from "../views/Statistics";
import Analysis from "../views/Analysis";
import ScheduleBasic from "../views/ScheduleBasic";
import ScheduleAdvanced from "../views/ScheduleAdvanced";
import Bets from "../views/Bets";
import Settings from "../views/Settings";
import Logs from "../views/Logs";
import Dashboards from "../views/Dashboards";
import Debug from "../views/Debug";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Summary",
    component: Home
  },
  {
    path: "/monitored",
    name: "Monitored Races",
    component: MonitoredRaces
  },
  {
    path: "/upcoming",
    name: "Upcoming Races",
    component: UpcomingRaces
  },
  {
    path: "/statistics",
    name: "Statistics",
    component: Statistics
  },
  {
    path: "/analysis",
    name: "Analysis",
    component: Analysis
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    component: Dashboards
  },
  {
    path: "/bets",
    name: "Placed Bets",
    component: Bets
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings
  },
  {
    path: "/schedule-advanced",
    name: "Schedule",
    component: ScheduleAdvanced
  },
  {
    path: "/schedule-basic",
    name: "Schedule",
    component: ScheduleBasic
  },
  {
    path: "/logs",
    name: "Logs",
    component: Logs
  },
  {
    path: "/debug",
    name: "Debug",
    component: Debug
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
